import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import AyacuchoIcon from "../../assets/images/ayacucho/lg.png";
import Schedule from "./Schedule.js";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Style from "../../styles/js/Styles";
import { MapContainer, TileLayer } from "react-leaflet";
import * as Constants from "../../consts/Constants.js";
import * as Nominatim from "nominatim-browser";
import { ColorButton } from "../../components/common/CustomButton.js";
import RedMarker from "../../assets/images/markers/redMarker.png";

import { supportsGoWithoutReloadUsingHash } from "history/DOMUtils";

export default function EditBusiness({
  handleClose,
  handleChange,
  handleLocation,
  save,
  handleSchedule,
  inputsForm,
  errors,
  errorsMessages,
  setErrors,
}) {
  // Geodecode
  const onSuggestsLookup = () => {
    let input = inputsForm.address + " Ayacucho, buenos aires, Argentina";
    return Nominatim.geocode({
      q: input,
      addressdetails: true,
    })
      .then((results) => {
        var result = results[0];
        setCenter({ lat: result.lat, lng: result.lon });
        if (map != null) map.setView([result.lat, result.lon], 18);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [center, setCenter] = React.useState({
    lat: Constants.LATITUD_AYACUCHO,
    lng: Constants.LONGITUD_AYACUCHO,
  });

  const [map, setMap] = React.useState(null);

  const style = Style();
  const categories = [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 99];
  const categoriesName = [
    "Desconocido",
    "Mercado o despensa",
    "Carnes",
    "Frutas y Verduras",
    "Panaderia",
    "Gastronomia",
    "Farmacia",
    "Mascotas",
    "Tienda o negocio",
    "Envios y mensajería",
    "Otro",
  ];

  const localSave = () => {
    let location = map.getCenter().lat + "," + map.getCenter().lng;
    handleLocation(location);
    save();
  };

  useEffect(() => {
    if (inputsForm.location !== undefined && inputsForm.location !== "") {
      let location = inputsForm.location.split(",");
      setCenter({ lat: location[0], lng: location[1] });
    } else
      setCenter({
        lat: Constants.LATITUD_AYACUCHO,
        lng: Constants.LONGITUD_AYACUCHO,
      });
  }, []);

  return (
    <Dialog fullScreen open onClose={handleClose}>
      <form className={style.rootBusiness} autoComplete="off">
        <AppBar className={style.appBarForm}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={style.title}>
              Edición de Comercio
            </Typography>
            <img src={AyacuchoIcon} alt="Ayacucho" className={style.image} />
            <Button
              style={{ marginLeft: "auto", float: "right" }}
              onClick={localSave}
              autoFocus
              color="inherit"
            >
              Guardar
            </Button>
          </Toolbar>
        </AppBar>
        <div className={style.column}>
          <div className={style.flexRow} style={{ paddingTop: "10px" }}>
            <TextField
              id="name"
              label="Nombre"
              name="name"
              error={errors.name}
              className={style.inputText}
              style={{ width: "50%", padding: "5px" }}
              helperText={errors.name ? errorsMessages.name : " "}
              value={inputsForm.name}
              onChange={handleChange}
              placeholder="Nombre del comercio"
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              id="address"
              label="Direccion"
              name="address"
              value={inputsForm.address}
              error={errors.address}
              style={{ width: "35%", padding: "5px" }}
              helperText={errors.address ? errorsMessages.address : " "}
              onChange={handleChange}
              placeholder="Avenida 123"
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
            />

            <ColorButton
              style={{ width: "15%", height: "40px", padding: "5px" }}
              onClick={onSuggestsLookup}
              className={style.searchButton}
              variant="contained"
            >
              BUSCAR
            </ColorButton>
          </div>
          <div className={style.flexRow}>
            <TextField
              id="phoneNumbers"
              label="Telefono"
              name="phoneNumbers"
              error={errors.phoneNumbers}
              style={{ width: "50%", padding: "5px" }}
              helperText={
                errors.phoneNumbers ? errorsMessages.phoneNumbers : " "
              }
              value={inputsForm.phoneNumbers}
              onChange={handleChange}
              placeholder="+5492494444"
              fullWidth
              required
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="whatsApp"
              label="WhatsApp"
              name="whatsApp"
              error={errors.whatsApp}
              style={{ width: "50%", padding: "5px" }}
              helperText={errors.whatsApp ? errorsMessages.whatsApp : " "}
              value={inputsForm.whatsApp}
              onChange={handleChange}
              placeholder="+54924944444"
              fullWidth
              required
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className={style.flexRow}>
            <TextField
              id="ownerDni"
              label="DNI propietario"
              name="ownerDni"
              error={errors.ownerDni}
              style={{ width: "50%", padding: "5px" }}
              helperText={errors.ownerDni ? errorsMessages.ownerDni : " "}
              value={inputsForm.ownerDni}
              onChange={handleChange}
              type="number"
              placeholder="11.111.111"
              fullWidth
              required
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="webSite"
              label="Website"
              name="webSite"
              style={{ width: "50%", padding: "5px" }}
              value={inputsForm.webSite}
              onChange={handleChange}
              placeholder="www.sitioweb.com"
              fullWidth
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className={style.flexRow}>
            <TextField
              id="keywords"
              label="Palabras Clave"
              name="keywords"
              error={errors.keywords}
              style={{ width: "100%", padding: "5px" }}
              helperText={errors.keywords ? errorsMessages.keywords : " "}
              value={inputsForm.keywords}
              onChange={handleChange}
              placeholder="Ferreteria, Pintureria, Pesca"
              fullWidth
              multiline
              rowsMax={4}
              required
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className={style.flexRow}>
            <div style={{ width: "50%", padding: "5px" }}>
              <InputLabel
                required
                shrink
                id="demo-simple-select-placeholder-label-label"
              >
                Categoria
              </InputLabel>
              <Select
                name="category"
                fullWidth
                onChange={handleChange}
                labelId="label"
                id="select"
                value={inputsForm.category}
              >
                {categories.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {categoriesName[index]}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div style={{ width: "50%", padding: "5px" }}>
              <InputLabel
                required
                shrink
                id="demo-simple-select-placeholder-label-label"
              >
                Delivery
              </InputLabel>
              <Select
                fullWidth
                onChange={handleChange}
                name="delivery"
                labelId="label"
                id="select"
                placeholder="SI"
                value={inputsForm.delivery}
              >
                <MenuItem key={0} value={false}>
                  NO
                </MenuItem>
                <MenuItem key={1} value={true}>
                  SI
                </MenuItem>
              </Select>
            </div>
          </div>
        </div>

        <div className={style.column}>
          <MapContainer
            style={{
              height: "100%",
              width: "100%",
              overflow: "hidden",
              zIndex: 399,
            }}
            center={center}
            zoom={18}
            scrollWheelZoom={true}
            whenCreated={setMap}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </MapContainer>

          <img
            style={{
              alignSelf: "center",
              width: "30px",
              position: "fixed",
              zIndex: 500,
              transform: "translate(0, -30px)",
            }}
            src={RedMarker}
          ></img>
        </div>
        <div className={style.flexRowSchedule}>
          <Schedule
            days={inputsForm.schedule}
            handleSchedule={handleSchedule}
          />
        </div>
        <div
          className={style.flexRow}
          style={{ justifyContent: "center", color: "red" }}
          width="100%"
        >
          {errors.schedule && errorsMessages.schedule}
        </div>
      </form>
    </Dialog>
  );
}
